import Relay from 'react-relay';

export default class ChangeStepMutation extends Relay.Mutation {
  getMutation() {
    return Relay.QL`mutation{changeStep}`;
  }

  getVariables() {
    return {
      conversationId: this.props.conversationId,
      updatedStep: this.props.updatedStep
    };
  }

  getFatQuery() {
    return Relay.QL`
      fragment on ChangeStepPayload {
        conversation {
          step
        }
      }
    `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        conversation: this.props.conversationRelayId
      }
    }];
  }
}



/** WEBPACK FOOTER **
 ** ./src/mutations/ChangeStepMutation.js
 **/